export default __webpack_public_path__ + "static/halim-04897cc0142a76737b653a20a1c0849a.jpg";